import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Gift } from '../components/gift';

export const GiftsShowcase = () => (
  <StaticQuery
    query={graphql`
      query GiftsShowcaseQuery {
        allMarkdownRemark(
          limit: 4
          filter: { frontmatter: { type: { eq: "gift" }, main_page: { eq: true } } }
          sort: { fields: [frontmatter___sort_order] }
        ) {
          edges {
            node {
              id
              frontmatter {
                title
                description
                price
                image {
                  childImageSharp {
                    fluid(maxWidth: 400, maxHeight: 300, quality: 65) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      return (
        <div className="columns is-mobile is-multiline">
          {data.allMarkdownRemark.edges.map(({ node }) => {
            const gift = {
              title: node.frontmatter.title,
              description: node.frontmatter.description,
              price: node.frontmatter.price,
              image: node.frontmatter.image,
              slug: node.fields.slug,
            };

            return (
              <div
                className="column is-half-mobile is-half-tablet is-one-quarter-desktop"
                key={node.id}
              >
                <Gift {...gift} />
              </div>
            );
          })}
        </div>
      );
    }}
  />
);
